/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: actualite-webapp-front
 * Version: 7.4.0-ALPHA-2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import Switcher from '@kuik/modules/switcher/switcher.js';
import {refreshResults, refreshFilters} from '@webapp-front/scripts/search/search-common.js';
import {handlePaginationActions} from '@webapp-front/scripts/search/search-pagination.js';

/**
 * Rafraichit le corps de la recherche.
 * @param event {Event} - L'événement.
 */
async function refreshSearchBody(event) {
    if (event) {
        event.preventDefault();
    }
    await refreshResults('search-body');
    await refreshFilters();
    mountFiltersForViewport();
}

/**
 * Gère la sélection des inputs de recherche.
 */
function handleSearchInputSelection() {
    const searchInputs = document.querySelectorAll('.js-agenda-search-aggregation input');
    searchInputs.forEach((input) => {
        input.addEventListener('change', refreshSearchBody);
    });
}

/**
 * Gère la désélection de tous les inputs de recherche.
 */
function handleSearchUncheckAllSelection() {
    const searchInputs = document.querySelectorAll('.js-agenda-uncheck-all  input[type="checkbox"]');
    searchInputs.forEach((input) => {
        input.addEventListener('change', (e) => {
            if (!e.target.checked) {
                return;
            }
            const inputName = e.target.dataset.uncheckName;
            const checkboxes = document.querySelectorAll(`input[name=${inputName}]`);
            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
            refreshSearchBody();
        });
    });
}

/**
 * Simulation de l'activation d'un radio bouton pour les facettes à valeur unique
 * @param event Événement de clic reçu
 */
function updateCheckedItemForExclusiveInputSelection(event) {
    event.target.closest('.pop-list').querySelectorAll('.k-radio').forEach((radio) => {
        radio.checked = false;
    });
    const kradio = event.target.closest('.js-agenda-search-aggregation-exclusive').querySelector('.k-radio');
    if (kradio) {
        kradio.checked = true;
    }
    refreshSearchBody();
}

/**
 * Mise à jour de l'interface au clic sur une facette à valeur unique
 */
function handleSearchExclusiveInputSelection() {
    const searchinputs = document.querySelectorAll('.js-agenda-search-aggregation-exclusive');
    searchinputs.forEach((input) => {
        input.addEventListener('click', updateCheckedItemForExclusiveInputSelection);
        input.addEventListener('keydown', (event) => {
            if ([ 'Enter', 'Spacebar', ' ', 13, 10 ].includes(event.key ?? event.keyCode)) {
                event.preventDefault();
                input.click();
            }
        });
    });
}

/**
 * Rafraichit la recherche sur lors de l'appui sur le bouton de recherche.
 */
function handleSearchButton() {
    const searchButton = document.querySelector('.js-agenda-search-send-form');
    if (searchButton) {
        searchButton.addEventListener('click', refreshSearchBody);
    }
}

/**
 * Gère les actions.
 */
export function handleActions() {
    handleSearchInputSelection();
    handleSearchExclusiveInputSelection();
    handleSearchButton();
    handlePaginationActions();
    handleSearchUncheckAllSelection();
}

const mediaQuery = window.matchMedia('(min-width: 53rem)');

/**
 * Monte la variante mobile ou desktop du panneau de filtres selon le viewport, et
 * (re)branche les actions sur le contenu effectivement affiché.
 */
function mountFiltersForViewport() {
    const componentFilters = document.getElementById('component-agenda-filters');
    if (!componentFilters) {
        return;
    }
    const switcher = new Switcher('agenda-filters-mobile', {element: componentFilters, onMounted: handleActions});
    switcher.registerComponent('agenda-filters-desktop', {
        element: document.getElementById('component-agenda-filters-desktop'),
        onMounted: handleActions
    });
    switcher.switch(mediaQuery.matches ? 'agenda-filters-desktop' : 'agenda-filters-mobile');
}

mountFiltersForViewport();
mediaQuery.addEventListener('change', mountFiltersForViewport);
